import { z } from 'zod';

// Base schema for both sign-in and sign-up
const baseSchema = {
  email: z.string().email('Please enter a valid email address'),
  password: z.string().min(8, 'Password must be at least 8 characters long'),
};

// Sign-in schema (email + password only)
export const signInFormSchema = z.object(baseSchema);

// Sign-up schema (email + password + invitation_id)
export const signUpFormSchema = z.object({
  ...baseSchema,
  invitation_id: z
    .string()
    .length(32, 'Invitation code must be exactly 32 characters')
    .regex(/^[a-f0-9]{32}$/i, 'Invalid invitation code format'),
});

// Types
export type SignInFormSchema = z.infer<typeof signInFormSchema>;
export type SignUpFormSchema = z.infer<typeof signUpFormSchema>;

// Legacy export for backwards compatibility
export const formSchema = signInFormSchema;
export type FormSchema = SignInFormSchema;
